import * as React from 'react';
import clsx from 'clsx';

type Props = {
  className?: string;
  ko?: boolean;
  children?: React.ReactNode;
  color?: 'MAIN' | 'SUCCESS' | 'WARNING' | 'ERROR' | 'INFO';
  rounded?: boolean;
  bold?: boolean;
};

const Tag = ({
  className,
  children,
  ko,
  color,
  rounded,
  bold,
  ...props
}: Props) => (
  <span
    className={clsx(
      'tag',
      className,
      ko && 'tag--ko',
      color && `tag--${color.toLowerCase()}`,
      rounded && 'tag--rounded',
      bold && 'tag--bold',
    )}
    aria-hidden={ko}
    {...props}
  >
    {children}
  </span>
);

export default Tag;
